const ICON_PADDING = "2px";

export { ICON_PADDING };
